import { render, staticRenderFns } from "./Account.html?vue&type=template&id=07bf699d&"
import script from "./Account.ts?vue&type=script&lang=ts&"
export * from "./Account.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_account.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports